import { css } from '@/styled-system/css';

export const secondaryColumnStyles = css.raw({
  flexDirection: 'column',
  alignSelf: 'stretch',
  width: '100%',
  position: 'relative', // Needed for the Attachments Uploader positioning
  xxl: {
    minWidth: 0,
    maxWidth: '50%',
    borderRight: '1px solid',
    borderRightColor: 'border.muted',
  },
});
